<template>
  <aside
    class="overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs bg-analiza-sidebar"
    id="sidenav-main"
  >
    <div class="sidenav-header p-4">
      <button
        v-if="!isDesktop"
        type="button"
        class="sidenav-tab-btn bg-analiza-dark"
        id="iconSidenav"
        :aria-label="isSidenavOpen ? 'Ocultar menú lateral' : 'Mostrar menú lateral'"
        :aria-expanded="`${isSidenavOpen}`"
        @click="toggleSidenav"
      >
        <i :class="isSidenavOpen ? 'fas fa-times' : 'fas fa-bars'" aria-hidden="true"></i>
      </button>
      <a class="m-0 navbar-brand" href="/">
        <img :src="logo" class="navbar-brand-img h-100" alt="main_logo" />
      </a>
    </div>
   <!--<hr class="mt-0 horizontal dark" />-->
    <sidenav-list :cardBg="customClass" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-optimiza-blanco.png";
import { mapMutations, mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      isDesktop: true,
    };
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["isPinned", "isRTL"]),
    isSidenavOpen() {
      return this.isPinned;
    },
  },
  mounted() {
    this.syncSidenavMode();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapMutations(["navbarMinimize", "setSidenavState"]),
    toggleSidenav() {
      this.navbarMinimize();
    },
    handleResize() {
      const nextIsDesktop = window.innerWidth >= 1200;
      if (nextIsDesktop !== this.isDesktop) {
        this.syncSidenavMode();
      }
    },
    syncSidenavMode() {
      this.isDesktop = window.innerWidth >= 1200;
      this.setSidenavState(this.isDesktop);
    },
  },
};
</script>
